import { Classes } from "@blueprintjs/core";
import { BlockView } from "common/views/block/BlockView.view";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import MutationButton from "common/views/button/MutationButton";
import { DialogView } from "common/views/dialog/Dialog.view";
import { CreditClaimComplete } from "panels/subscriptions/entities/CreditComplete";
import { useState } from "react";
import { MutationType } from "typegraph";
import labelProvider from '../../panels/subscriptions/Subscriptions.labels';
const { Labels } = labelProvider;

export default function claimComplete(subscription) {
    const [isOpen, toggleOpen] = useState(false);
    return (<BlockView viewKey="claim-complete-block" key={subscription.id}>
        <DialogView isOpen={isOpen} onClose={() => toggleOpen(!isOpen)} viewKey="dialog" title="Credits Claim Complete"
            onClosed={() => toggleOpen(!isOpen)}>
            <div className={Classes.DIALOG_BODY}>
                <BlockView viewKey="claim.complete.message">
                    <Labels.ClaimCompleteMessage />
                </BlockView>

                &nbsp;&nbsp;

                <BlockView viewKey="claim-button-complete">
                    <MutationButton
                        key={subscription.id}
                        variant={ButtonVariant.PRIMARY}
                        viewKey="credit.claim.complete"
                        clazz={CreditClaimComplete}
                        params={{ id: subscription.id }}
                        clearCacheOnSuccess={true}
                        method={MutationType.UPDATE}
                    >
                        <Labels.Yes />
                    </MutationButton>
                </BlockView>
            </div>

        </DialogView>

        <ButtonView viewKey="claim.complete.button" variant={ButtonVariant.PRIMARY} onClick={() => toggleOpen(!isOpen)}>
            <Labels.ClaimComplete />
        </ButtonView>
    </BlockView>)
}


// WEBPACK FOOTER //
// ./src/common/fragments/CompleteCreditClaim.tsx